/**
 * Frontend-owned public URLs. These IDs were verified against the production
 * public profile API. Keep slugs stable when a provider changes its display name.
 * Approval and profile content always come from the API, not this map.
 */
export const PUBLIC_PROVIDER_PROFILES = [
  { slug: "ap-research", providerId: 4 },
  { slug: "eliant-capital", providerId: 5 },
  { slug: "citrini-research", providerId: 9 },
  { slug: "hfi-research", providerId: 10 },
  { slug: "aurelion-research", providerId: 11 },
  { slug: "blind-squirrel-macro", providerId: 13 },
  { slug: "cestrian-capital-research", providerId: 16 },
] as const;

export function getPublicProviderId(slug: string): number | null {
  return PUBLIC_PROVIDER_PROFILES.find(provider => provider.slug === slug)?.providerId ?? null;
}

export function getPublicProviderProfilePath(providerId: number): string | null {
  const provider = PUBLIC_PROVIDER_PROFILES.find(provider => provider.providerId === providerId);
  return provider ? `/providers/${provider.slug}` : null;
}
